/**
 * Created by rkamysz on 6/19/2015.
 */

// import { IOutputHandler } from "../../framework/api/IOutputHandler";
// import { InGamePerformanceEvent } from "../../../tracking/InGamePerformanceEvent";
// import { TrackingCache } from "../../../tracking/TrackingCache";
// import { TrackingEventIds } from "../../../tracking/constants/TrackingEventIds";

import { FPS_MEASUREMENT_LOGGER } from "./IMeasurements";

import { getLogger } from "@goodgamestudios/logger";

export class FpsMeasurementTrackingEventHandler /* implements IOutputHandler */ {
    // private event: InGamePerformanceEvent;

    private logger = getLogger(FPS_MEASUREMENT_LOGGER);

    constructor() {
        // this.event = (<InGamePerformanceEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.IN_GAME_PERFORMANCE));
    }

    public parse(measurementDuration: number, measurementResults: Object, gameData: Object): void {
        // this.event.gameId = gameData.gameId;
        // this.event.networkId = gameData.networkId;
        // this.event.instanceId = gameData.instanceId;
        // this.event.playerId = gameData.playerId;
        // this.event.sessionId = gameData.sessionId;
        // this.event.sessionTime = gameData.sessionTime;
        // this.event.date = gameData.date;
        // this.event.level = gameData.level;
        // this.event.deviceId = gameData.deviceId;
        // this.event.storeId = gameData.storeId;
        // this.event.memoryUsage = gameData.memoryUsage;
        // this.event.buildVersion = gameData.buildVersion;
        // this.event.lang = gameData.lang;
        // this.event.connectionType = gameData.connectionType;
        // this.event.fps = measurementResults.averageFps;
        // this.event.maxFps = measurementResults.maxFps;
        // this.event.minFps = measurementResults.minFps;
        // this.event.measurementDuration = measurementDuration;
        // this.event.inGameState = gameData.inGameState;
        // this.event.animations = gameData.animations;
        this.logger.debug("FpsMeasurementTrackingEventHandler.parse is not implemented yet");
    }

    public send(): void {
        // TrackingCache.getInstance().sendEvent(TrackingEventIds.IN_GAME_PERFORMANCE);
        this.logger.debug("FpsMeasurementTrackingEventHandler.send is not implemented yet");
    }
}
